var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./enum'),
    TxOp = _require.TxOp,
    ContractMode = _require.ContractMode;

var _require2 = require('./ecc'),
    stableHashObject = _require2.stableHashObject;

module.exports =
/*#__PURE__*/
function () {
  "use strict";

  // create contract
  // data = {
  //    op: 0,
  //    src: "console.log('hello world')";
  // }
  // call contract function
  // data = {
  //    op: 1,
  //    name: "functionName",
  //    params: [1, "hello"]
  // }
  //
  // Some op in the future: set alias/options, vote, etc.
  function _class(_ref) {
    var from = _ref.from,
        to = _ref.to,
        payer = _ref.payer,
        value = _ref.value,
        fee = _ref.fee,
        data = _ref.data,
        nonce = _ref.nonce;

    _classCallCheck(this, _class);

    this.from = from || '';
    this.to = to || '';
    this.payer = payer || '';
    this.value = String(value || '');
    this.fee = String(fee || '');
    this.data = data || {};
    this.nonce = nonce || Date.now() + Math.random(); // FIXME
    // some validation

    if (this.isContractCreation()) {
      if (this.data.mode !== undefined && this.data.mode !== ContractMode.JS_RAW && this.data.mode !== ContractMode.WASM) {
        throw new Error('Invalid contract source mode: ' + this.data.mode);
      } else if (!this.data.src) {
        throw new Error('You must provide contract source to deploy contract.');
      }
    }

    var content = {
      from: this.from,
      to: this.to,
      payer: this.payer,
      value: this.value,
      fee: this.fee,
      data: this.data,
      nonce: this.nonce
    };
    this.sigHash = stableHashObject(content);
  }

  _createClass(_class, [{
    key: "setEvidence",
    value: function setEvidence(evidence) {
      this.evidence = evidence;
      return this;
    }
  }, {
    key: "messageName",
    value: function messageName() {
      return this.data == undefined ? undefined : this.data.name; // eslint-disable-line
    }
  }, {
    key: "messageParams",
    value: function messageParams() {
      return this.data == undefined ? undefined : this.data.params || []; // eslint-disable-line
    }
  }, {
    key: "isSimpleTransfer",
    value: function isSimpleTransfer() {
      return this.data == undefined || this.data.op == undefined; // eslint-disable-line
    }
  }, {
    key: "isContractCreation",
    value: function isContractCreation() {
      return this.data && this.data.op === TxOp.DEPLOY_CONTRACT;
    }
  }, {
    key: "isContractCall",
    value: function isContractCall() {
      return this.data && this.data.op === TxOp.CALL_CONTRACT;
    }
  }]);

  return _class;
}();